var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right_Icon_",
    "data-name": "Right Icon ",
    transform: "translate(859 8917)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37820",
    "data-name": "Ellipse 37820",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(-859 -8917)",
    fill: "#47d764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858295",
    "data-name": "Path 858295",
    d: "M27.186,9.077,16.852,22.746,12.4,16.978a2.737,2.737,0,0,0-4.32,3.363l6.643,8.5a2.742,2.742,0,0,0,4.32-.027l12.494-16.4a2.75,2.75,0,0,0-4.374-3.335Z",
    transform: "translate(-854.797 -8911.938)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/Right Icon.1c53d8248a295d9a74469b57f68febe4.svg";
export { ForwardRef as ReactComponent };